import { HocuspocusProvider } from '@hocuspocus/provider'
import { useSession } from '@supabase/auth-helpers-react'

import * as Y from 'yjs'
import { useMemo, useEffect } from 'react'
import { atoms } from 'website/src/lib/atoms'
import { Cursor } from 'website/src/lib/editor-types'
import { isTruthy, userToCursorUser } from 'website/src/lib/editor-utils'
import { useRootProps } from 'website/src/lib/hooks'
import { deduplicateByKeyFn } from 'website/src/lib/utils'
import { env } from 'website/src/lib/env'

export function SiteCursors() {
    const {
        pageId,
        siteId,
        branchId,

        pageSlug,
        websocketToken,
    } = useRootProps()
    const session = useSession()

    const provider = useMemo(() => {
        if (typeof window === 'undefined') {
            return null
        }
        const document = new Y.Doc()
        const parameters = {
            siteId,
            branchId,
        }
        atoms.websocketToken.set(websocketToken)
        const p = new HocuspocusProvider({
            url: new URL(
                `/site-cursors/${siteId}/${branchId}`,
                env.NEXT_PUBLIC_HOCUSPOCUS_URL,
            ).toString(),
            name: `${siteId}/${branchId}`,
            token: websocketToken,

            document,

            parameters,
            onAwarenessChange({ states }) {
                if (!states) {
                    return
                }
                const siteCursorsSegments = deduplicateByKeyFn(
                    states.map((x) => x.siteCursor)?.filter(isTruthy),
                    (x) => x?.user?.email,
                )
                const siteCursors: Record<string, Cursor[]> = {}
                // for (let id of Object.keys(siteCursorsSegments)) {
                //     const user = cursor.user

                // }
                for (let cursor of siteCursorsSegments) {
                    const id = cursor.pageSlug
                    if (!siteCursors[id]) {
                        siteCursors[id] = []
                    }

                    if (
                        !siteCursors[id].some(
                            (x) => x.email === cursor.user.email,
                        )
                    ) {
                        siteCursors[id].push(cursor.user)
                    }
                }
                // console.log(JSON.stringify(siteCursors, null, 2))
                // console.log(siteCursors)
                atoms.siteCursors.set(siteCursors || {})
            },
        })
        return p
    }, [])

    useEffect(() => {
        return () => {
            provider?.awareness?.setLocalState(null)
            provider?.disconnect()
        }
    }, [provider])

    useEffect(() => {
        const user = userToCursorUser(session?.user, 'You')
        // user.name = 'You'
        provider?.awareness?.setLocalState({
            ...provider?.awareness?.getLocalState(),
            siteCursor: {
                user,
                pageId,
                pageSlug,
            },
        })
        return () => {
            provider?.awareness?.setLocalState(null)
        }
    }, [provider, session?.user?.email, pageId])
    return null
}
